<template>
  <PageHeader :showBreadcrumb="true" />
</template>

<script>
import PageHeader from "@/components/common/PageHeader.vue";

export default {
  name: "Attestation.vue",
  components: {PageHeader}
};
</script>

<style scoped>
.tx-p {
  padding: 1.5rem;
  height: 200px;
}
</style>